module.exports = __webpack_public_path__ + "img/26.517d124a.jpg";